export const de = {
  "common": {
    "brand": "Fyrrehaven 61",
    "bookNow": "Auf Airbnb buchen",
    "sleepsX": "Platz für {{count}} Gäste",
    "form": {
      "selectPlaceholder": "Auswählen",
      "chooseFile": "Datei auswählen",
      "chooseFiles": "Dateien auswählen",
      "required": "Dieses Feld ist erforderlich",
      "emailMismatch": "E-Mail und E-Mail-Bestätigung müssen übereinstimmen.",
      "fileAlreadyAdded": "Dieses Foto wurde bereits hinzugefügt. Entfernen Sie es zuerst, wenn Sie ein anderes Foto auswählen möchten.",
      "maxFilesReached": "Sie können bis zu {{count}} Zählerfotos hochladen.",
      "moreFileIssues": "{{count}} weiteres Problem benötigt Aufmerksamkeit."
    }
  },
  "home": {
    "heroTitle": "Familienfreundliches Ferienhaus im Wald – in der Nähe des Strandes",
    "heroSubtitle": "Pool, Whirlpool, Sauna, Aktivitätsraum und Platz für die ganze Familie.",
    "ctaSeeHouse_da": "Se huset",
    "ctaSeeHouse_en": "See the house",
    "badgePool": "Beheizter Außenpool",
    "badgeHotTub": "Whirlpool",
    "badgeActivityRoom": "Aktivitätsraum",
    "badgeBeach": "In Strandnähe",
    "altKitchen": "Helle Wohnküche",
    "altPool": "Beheizter Außenpool",
    "altHotTub": "Whirlpool im Garten",
    "altBeach": "Strand bei Fjellerup",
    "whyFamiliesTitle": "Warum Familien Fyrrehaven 61 lieben",
    "whyFamiliesSub": "Alles was Sie für einen gemütlichen Urlaub brauchen – mit der Natur direkt vor der Tür.",
    "featSleeps": "Platz für {{count}} Gäste (Bettaufteilung und Familienausstattung)",
    "featPool": "Beheizter Außenpool in der Saison",
    "featHotTub": "Entspannung im Whirlpool unter den Kiefern",
    "featActivityRoom": "Aktivitätsraum mit Billard, Tischtennis, Airhockey, Darts und Projektor",
    "featBeach": "Kurzer Spaziergang zum Strand und zur Eisdiele",
    "featForest": "Waldgebiet mit Spielplätzen und Wanderwegen",
    "featKids": "Hochstuhl, Reisebett und Familienbrettspiele",
    "featWifi": "Schnelles Wi-Fi zum Streaming und Arbeiten",
    "featParking": "Kostenlose Parkplätze am Haus",
    "reviewsTitle": "Bewertungen von Gästen",
    "reviewsSub": "Wir verlinken auf Airbnb für alle Bewertungen.",
    "quote1": "Perfekt für Kinder – sie liebten das Pool!",
    "quote2": "Ruhige Gegend nah an Strand und Wald.",
    "quote3": "Sauber, hell und leicht zu buchen.",
    "seeMoreOnAirbnb": "Mehr auf Airbnb sehen",
    "mapTitle": "Fyrrehaven 61 auf der Karte",
    "readyTitle": "Bereit zu buchen?",
    "readySub": "Verfügbarkeit und Preise auf Airbnb ansehen."
  },
  "reviews": {
    "ariaLabel": "Bewertungen",
    "title": "Was unsere Gäste sagen",
    "ratingLabel": "{{value}} von 5",
    "scrollLeft": "Nach links scrollen",
    "scrollRight": "Nach rechts scrollen",
    "readMore": "Ganze Bewertung lesen",
    "showLess": "Weniger anzeigen",
    "emptyReview": "Dieser Gast hat eine Sternebewertung ohne schriftlichen Kommentar hinterlassen.",
    "source": "Quelle",
    "airbnbCta": "Alle Bewertungen auf Airbnb ansehen"
  },
  "book": {
    "hero": {
      "title": "Buchung",
      "subtitle": "Senden Sie eine direkte Anfrage – oder buchen Sie über Airbnb, wenn Sie das bevorzugen.",
      "badges": {
        "pool": "Beheizter Außenpool (1.5.–1.10.)",
        "guests": "Platz für 10 Gäste",
        "family": "Familienfreundlich"
      },
      "airbnbCta": "Booking Airbnb",
      "imageAlt": "Buchung des Ferienhauses bei Fjellerup"
    },
    "intro": {
      "title": "Wie möchten Sie buchen?",
      "body": "Sie können uns entweder eine direkte Anfrage über das Formular unten senden oder über Airbnb buchen, wenn Sie es bevorzugen. Wir antworten normalerweise innerhalb einer Stunde.",
      "noteTitle": "Gut zu wissen",
      "notePool": "Der Außenpool ist auf ca. 29 °C beheizt und vom 1. Mai bis 1. Oktober geöffnet. Max. 10 Gäste. Keine Partys.",
      "noteUtilities": "Strom: 4 DKK/kWh, Wasser: 80 DKK/m³ (Abrechnung nach dem Aufenthalt)."
    },
    "process": {
      "title": "So funktioniert die Buchung",
      "lead": "Es ist eine Anfrage – keine sofortige Reservierung. Wir melden uns schnell mit einem Mietvertrag oder einer freundlichen Absage.",
      "aria": "Buchungsprozess",
      "steps": {
        "request": {
          "title": "Anfrage senden",
          "body": "Wählen Sie Ihre gewünschten Daten im Kalender und füllen Sie das Formular unten aus."
        },
        "review": {
          "title": "Wir prüfen Ihre Anfrage",
          "bodyIntro": "Wir prüfen Verfügbarkeit, Gästeanzahl und Zweck des Aufenthalts.",
          "bodyRules": "Hausregeln: keine Partys und keine reinen Jugendgruppen unter {{minAge}} Jahren. Max. {{maxGuests}} Gäste."
        },
        "reply": {
          "title": "Antwort von uns (normalerweise innerhalb von {{responseHours}} Stunden)",
          "bodyIntro": "Sie erhalten eine Antwort von uns (normalerweise innerhalb von {{responseHours}} Stunden).",
          "bodyDetails": "Wenn alles passt, senden wir einen Mietvertrag mit Preis und praktischen Informationen. Falls die Daten nicht passen oder die Anfrage gegen die Hausregeln verstößt, schlagen wir Alternativen vor oder lehnen freundlich ab."
        },
        "confirm": {
          "title": "Sie unterschreiben – wir bestätigen",
          "bodyIntro": "Die Buchung ist erst endgültig bestätigt, wenn der Mietvertrag unterschrieben ist und die vereinbarten Zahlungen eingegangen sind.",
          "bodyDetails": "Danach erhalten Sie eine Willkommensmail mit Schlüsselinfos, Adresse und Anreisehinweisen."
        }
      },
      "note": {
        "label": "Hausregeln kurz:",
        "text": "keine Partys, keine reinen Jugendgruppen unter {{minAge}} Jahren und bitte Rücksicht auf die Nachbarn nehmen. Max. {{maxGuests}} Gäste.",
        "readMore": "Mehr hier lesen:",
        "fees": "Gebührenübersicht",
        "privacy": "Datenschutzerklärung"
      }
    }
  },
  "area": {
    "attractions": {
      "djurs-sommerland": {
        "title": "Djurs Sommerland",
        "description": "Skandinaviens größter Freizeitpark mit über 60 Attraktionen und Wasserpark."
      },
      "legerevet-grenaa": {
        "title": "Lege-revet (Grenaa) – Indoor-Spielparadies",
        "description": "Indoor-Spielparadies mit Klettergerüsten, Rutschen und Bällebad."
      },
      "hermans-hule-grenaa": {
        "title": "Hermans Hule (Grenaa) – Indoor-Spielparadies",
        "description": "Großes Indoor-Spielparadies mit Rutschen und Trampolinen."
      },
      "fjollehaven": {
        "title": "Fjollehaven",
        "description": "Großer Outdoor-Spielplatz"
      },
      "fjellerup-strand": {
        "title": "Fjellerup Strand",
        "description": "Breiter, familienfreundlicher Sandstrand in Fahrradentfernung."
      },
      "mols-bjerge": {
        "title": "Nationalpark Mols Bjerge",
        "description": "Hügelige Landschaften, schöne Aussichtspunkte und gute Wanderwege."
      },
      "kalo-slotsruin": {
        "title": "Kalø Schlossruine",
        "description": "Ikonische Burgruine an der Kalø Vig – schöner Spaziergang auf dem alten Steinweg."
      },
      "kattegatcentret": {
        "title": "Kattegatcentret (Grenaa)",
        "description": "Aquarium mit Haien und Robben – perfekt für windige oder kühle Tage."
      },
      "randers-regnskov": {
        "title": "Randers Regnskov",
        "description": "Tropische Kuppeln mit Tieren und Pflanzen – das ganze Jahr über."
      },
      "vaffelbageri": {
        "title": "Fjellerup Vaffelbageri",
        "description": "Berühmte Waffeln am Strand – saisonal geöffnet."
      },
      "vaffelbageri-food": {
        "title": "Fjellerup Vaffelbageri - Fastfood",
        "description": "Eis und Fastfood – saisonal geöffnet."
      },
      "vaffelhuset": {
        "title": "Vaffelhuset",
        "description": "Hausgemachtes Eis – saisonal geöffnet."
      },
      "brugsen-fjellerup": {
        "title": "Brugsen Fjellerup Strand",
        "description": "Lokaler Lebensmittelmarkt für alles Praktische."
      },
      "alt-til-dagen": {
        "title": "Alt Til Dagen",
        "description": "Lokaler Lebensmittelmarkt für alles Praktische."
      }
    }
  },
  "contact": {
    "hero": {
      "title": "Kontakt aufnehmen",
      "subtitle": "Wir antworten normalerweise schnell – oft innerhalb weniger Stunden.",
      "badges": {
        "family": "Familienfreundlich",
        "beach": "In Strandnähe"
      },
      "imageAlt": "Die Familie hinter dem Haus",
      "primaryCta": "Direkt buchen",
      "secondaryCta": "Booking Airbnb"
    },
    "form": {
      "heading": "Schreiben Sie uns",
      "submit": {
        "message": "Nachricht senden",
        "booking": "Anfrage senden",
        "sendingMessage": "Nachricht wird gesendet...",
        "sendingBooking": "Anfrage wird gesendet...",
        "aria": "Formular senden"
      },
      "success": {
        "messageTitle": "Vielen Dank für Ihre Nachricht!",
        "bookingTitle": "Vielen Dank für Ihre Buchungsanfrage!",
        "messageLead": "Wir melden uns so schnell wie möglich. Hier ist eine Kopie Ihrer Nachricht:",
        "bookingLead": "Wir melden uns so schnell wie möglich. Hier ist eine Übersicht Ihrer Anfrage:"
      }
    }
  },
  "fees": {
    "page": {
      "title": "Gebühren",
      "lead": "Damit alle Gäste die bestmögliche Erfahrung haben, haben wir eine Übersicht über Gebühren zusammengestellt, die in besonderen Situationen relevant werden können.",
      "infoTitle": "Wichtige Informationen zur Buchung des Ferienhauses",
      "badges": {
        "noParties": "Keine Vermietung für Partys oder Gruppen unter 25 Jahren.",
        "noPets": "Keine Haustiere im Innenbereich erlaubt.",
        "pool": "Außenpool geöffnet vom 1. Mai bis 1. Oktober."
      },
      "consumptionTitle": "Verbrauch wird nach dem Aufenthalt abgerechnet",
      "consumptionElectricity": "Strom- und Wasserverbrauch gemäß Mietvertrag.",
      "consumptionExtras": "Wenn nach der Buchung Zusatzleistungen bestellt werden, werden diese berechnet.",
      "listTitle": "Gebührenübersicht",
      "footer": "Hinweis: Gebühren können erhoben werden, wenn Bedingungen nicht eingehalten werden. Kontaktieren Sie uns bei Fragen."
    },
    "items": {
      "early-checkin-unauthorized": {
        "title": "Früher Check-in ohne vorherige Genehmigung",
        "unit": "pro angefangene halbe Stunde"
      },
      "late-checkout-unauthorized": {
        "title": "Später Check-out ohne vorherige Genehmigung",
        "unit": "pro angefangene halbe Stunde"
      },
      "hottub-over-42c": {
        "title": "Whirlpool-Temperatur übersteigt 42°C",
        "note": "gilt nur für den Whirlpool"
      },
      "hottub-damage": {
        "title": "Schäden am Whirlpool",
        "note": "Mindestgebühr – tatsächliche Reparatur-/Ersatzkosten können hinzukommen."
      },
      "spa-tech-damage": {
        "title": "Schäden an Hot-Tub-Technik (Wärmepumpe, Wasserpumpe usw.)",
        "note": "Mindestgebühr – tatsächliche Reparatur-/Ersatzkosten können hinzukommen."
      },
      "grill-not-cleaned": {
        "title": "Grill nicht gereinigt"
      },
      "trash-not-disposed": {
        "title": "Abfall nicht entsorgt",
        "note": "gilt beim Check-out"
      },
      "dishwasher-not-emptied": {
        "title": "Geschirrspüler nicht geleert",
        "note": "gilt beim Check-out"
      },
      "outdoor-furniture-not-returned": {
        "title": "Gartenmöbel nicht zurückgestellt"
      },
      "loft-toys-not-tidied": {
        "title": "Dachboden und Spielzeug nicht aufgeräumt"
      },
      "doors-windows-not-locked": {
        "title": "Türen oder Fenster nicht abgeschlossen/geschlossen"
      },
      "noise-complaints": {
        "title": "Lärmbelästigung oder Beschwerden von Nachbarn"
      },
      "remotes-missing": {
        "title": "Fehlende Fernbedienungen",
        "unit": "pro Stück"
      },
      "keys-missing": {
        "title": "Fehlende Schlüssel für Haus oder Poolabdeckung",
        "unit": "pro Schlüssel"
      },
      "mattress-soiling": {
        "title": "Urin/Flüssigkeiten auf Betten und Matratzen",
        "unit": "pro Matratze"
      },
      "indoor-smoking": {
        "title": "Rauchen im Innenbereich (nicht erlaubt)"
      },
      "sauna-damage": {
        "title": "Schäden an der Sauna (Inventar/Verkleidung)",
        "note": "Mindestgebühr – tatsächliche Reparatur-/Ersatzkosten können hinzukommen."
      },
      "sauna-stove-damage": {
        "title": "Schäden am Saunaofen",
        "note": "Mindestgebühr – tatsächliche Kosten können hinzukommen."
      },
      "pool-tech-damage": {
        "title": "Schäden an der Pooltechnik (Pumpe, Filter, Wärmepumpe usw.)",
        "note": "Mindestgebühr – tatsächliche Kosten können hinzukommen."
      },
      "activity-table-damage": {
        "title": "Schäden am 3-in-1-Multispieltisch",
        "note": "Mindestgebühr – tatsächliche Reparatur-/Ersatzkosten können hinzukommen."
      },
      "dart-damage": {
        "title": "Schäden an Dartscheibe oder Schutzpolstern",
        "note": "Mindestgebühr – tatsächliche Reparatur-/Ersatzkosten können hinzukommen."
      }
    }
  },
  "extraServices": {
    "page": {
      "eyebrow": "Zusatzleistungen für den Aufenthalt",
      "title": "Zusatzleistungen",
      "lead": "Wir möchten Ihren bevorstehenden Aufenthalt so angenehm wie möglich machen. Deshalb bieten wir zusätzliche Leistungen an, die Sie hier anfragen können.",
      "listAria": "Liste der Zusatzleistungen",
      "includedTitle": "In der Miete enthalten",
      "includedText": "Geschirrtuch - Spültuch - Shampoo - Duschgel - Handseife - Spülmittel - Geschirrspülpulver - Kaffeebohnen"
    },
    "form": {
      "yes": "Ja",
      "no": "Nein",
      "select": "Auswählen",
      "free": "KOSTENLOS",
      "total": "Geschätzte Extras gesamt",
      "submit": "Anfrage senden",
      "sending": "Anfrage wird gesendet...",
      "success": "Danke. Ihre Anfrage zu Zusatzleistungen wurde gesendet.",
      "successFollowup": "Wir kümmern uns darum und melden uns nur, wenn etwas nicht möglich ist.",
      "summaryYes": "Der Gast möchte Zusatzleistungen.",
      "summaryNo": "Der Gast möchte derzeit keine Zusatzleistungen.",
      "noSpecificItems": "Keine konkreten Mengen ausgewählt.",
      "dateHint": "Zusatzleistungen werden normalerweise spätestens 3 Tage vor Ankunft angefragt, damit wir alles vorbereiten können.",
      "lateNotice": "Späte Anfragen und Last-minute-Buchungen werden akzeptiert. Wir kümmern uns darum und melden uns nur, wenn etwas nicht möglich ist.",
      "bundleHint": "Komplettpaket mit Bettwaren, Bettwäsche und Handtüchern",
      "fields": {
        "name": "Buchende Person",
        "email": "E-Mail-Adresse",
        "confirmEmail": "E-Mail bestätigen",
        "stayDate": "Aufenthaltsdatum",
        "wantsExtras": "Möchten Sie Zusatzleistungen?",
        "otherRequests": "Weitere Wünsche?"
      },
      "placeholders": {
        "name": "Name der Person, die den Aufenthalt gebucht hat",
        "email": "name@email.de",
        "amount": "Gewünschte Anzahl",
        "otherRequests": "Schreiben Sie Ihre Wünsche hier, dann finden wir eine Lösung"
      },
      "hints": {
        "high-chair": "Ein Hochstuhl verfügbar",
        "baby-cot": "Ein Babybett verfügbar"
      },
      "calendar": {
        "previous": "Vorheriger Monat",
        "next": "Nächster Monat"
      },
      "acceptBefore": "Mit dem Setzen dieses Hakens bestätigen Sie, dass Sie eine Entscheidung zu Zusatzleistungen getroffen haben, der Verarbeitung Ihrer Anfrage zustimmen und unsere",
      "houseRules": "Hausregeln",
      "and": "und",
      "feeList": "Gebührenübersicht",
      "acceptAfter": "für mögliche Verstöße gelesen und akzeptiert haben. Der Code für den Schlüsselkasten wird 1 Stunde vor Ankunft gesendet, sobald dies bestätigt ist.",
      "errors": {
        "required": "Bitte füllen Sie Name, E-Mail, E-Mail-Bestätigung und Aufenthaltsdatum aus.",
        "dateTooSoon": "Bitte wählen Sie heute oder ein zukünftiges Anreisedatum.",
        "email": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
        "emailMismatch": "E-Mail und E-Mail-Bestätigung müssen übereinstimmen.",
        "dateNotBooked": "Wir können keine Buchung finden, die an diesem Datum beginnt. Bitte wählen Sie das Startdatum Ihrer Buchung.",
        "nameMismatch": "Der Name stimmt nicht mit der Buchung überein, die wir für dieses Datum gefunden haben. Bitte verwenden Sie denselben Namen wie in der Buchung.",
        "bookingCheckUnavailable": "Wir konnten den Buchungskalender gerade nicht prüfen. Bitte versuchen Sie es gleich noch einmal.",
        "bookingCheck": "Wir konnten Ihre Buchungsdaten nicht bestätigen. Bitte prüfen Sie Name und Datum und versuchen Sie es erneut.",
        "noSelection": "Bitte wählen Sie mindestens eine Zusatzleistung aus, wenn Sie mit Ja antworten.",
        "tooManyPeople": "Bettwaren, Bettwäsche, Handtücher und Pakete können insgesamt nur für bis zu 10 Personen bestellt werden.",
        "accept": "Bitte akzeptieren Sie Hausregeln und Gebührenübersicht vor dem Absenden.",
        "rateLimited": "Es wurden zu viele Anfragen in kurzer Zeit gesendet. Bitte warten Sie einen Moment und versuchen Sie es erneut.",
        "tooFast": "Bitte prüfen Sie das Formular noch einmal und senden Sie es in einem Moment erneut.",
        "formExpired": "Diese Formularsitzung ist abgelaufen. Bitte laden Sie die Seite neu und senden Sie die Anfrage erneut.",
        "security": "Die Anfrage konnte aus dieser Browsersitzung nicht angenommen werden. Bitte laden Sie die Seite neu und versuchen Sie es erneut.",
        "lateSubmit": "Ihre späte Anfrage konnte nicht automatisch gesendet werden. Da Ihr Aufenthalt kurz bevorsteht, kontaktieren Sie uns bitte direkt, damit wir es arrangieren können.",
        "network": "Die Verbindung wurde unterbrochen, bevor die Anfrage gesendet werden konnte. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
        "lateNetwork": "Die Verbindung wurde unterbrochen, bevor Ihre späte Anfrage gesendet werden konnte. Da Ihr Aufenthalt kurz bevorsteht, kontaktieren Sie uns bitte direkt, falls sie nicht durchgeht.",
        "submit": "Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es gleich noch einmal."
      }
    }
  },
  "guest": {
    "accordion": {
      "pool": {
        "duckkey": "Schlüssel für Poolabdeckung",
        "keyhole": "Schlüsselloch für Poolabdeckung"
      },
      "spa": {
        "rules": {
          "title": "Regeln und Nutzung",
          "note": "Hinweis!",
          "intro": "Sie müssen kein Brennholz für den Whirlpool mitbringen, da er elektrisch beheizt wird. Der Pool ist bei Ankunft sauber und bereit.",
          "maxTemp": "Maximale Temperatur 40°C.",
          "buttons": "An der Seite des Whirlpools befinden sich zwei Tasten",
          "button1": "Taste 1 — Licht",
          "button2": "Taste 2 — Massage/Blasen",
          "dial": "Stärke mit dem Drehknopf einstellen",
          "waterLevel": "Der Wasserstand darf die oberen Massagedüsen nicht überschreiten",
          "massageTemp": "Massage erst einschalten, wenn das Wasser über 20°C ist",
          "firewood": "Der Whirlpool wird elektrisch beheizt; verwenden Sie kein Brennholz.",
          "chlorine": "Chlortabletten halten das Wasser sauber",
          "drain": "Gäste müssen den Whirlpool nach dem Aufenthalt nicht entleeren.",
          "imageAlt": "Whirlpool",
          "caption": "Die Nutzung des Whirlpools erfolgt auf eigene Verantwortung."
        },
        "fire": {
          "title": "Whirlpool aufheizen",
          "fill": "Füllen Sie den Pool mit dem Gartenschlauch. Das dauert ca. 2 Stunden.",
          "heater": "Wenn das Wasser 10 cm über der oberen Öffnung des Ofens steht, können Sie anfeuern und 2 Chlortabletten hinzufügen.",
          "smoke": "Verwenden Sie trockenes Brennholz und sorgen Sie für eine gute Flamme, um schweren Rauch aus dem Schornstein zu vermeiden.",
          "wood": "Füllen Sie den Ofen etwa zu 2/3 mit Holz",
          "cover": "Thermoabdeckung auflegen und Geduld haben",
          "stopWood": "Wenn das Badewasser ca. 36°C erreicht hat, kein Holz mehr nachlegen.",
          "temp": "Wassertemperatur vor der Nutzung prüfen. Ideal sind 36–40°C",
          "close": "Nach der Nutzung die Thermoabdeckung schließen und am Ende das Wasser ablassen"
        }
      },
      "sauna": {
        "rules": {
          "title": "Regeln und Nutzung",
          "lightTitle": "Licht einschalten",
          "light": "Außerhalb der Sauna befindet sich ein Schalter für Innen- und Außenlicht.",
          "heaterTitle": "Heizgerät einstellen",
          "heater": "In der Sauna finden Sie unten am Ofen zwei Drehknöpfe:",
          "leftTitle": "Linker Knopf: Temperatur",
          "left": "Gewünschte Temperatur einstellen (70–80°C empfohlen).",
          "rightTitle": "Rechter Knopf: Zeit",
          "right": "Drehen, um die Sauna zu starten. Bei '0' startet sie sofort; hinter '0' wird die Timer-Funktion aktiviert.",
          "waitTitle": "Auf das Aufheizen warten",
          "wait": "Die Sauna ist nach ca. 30–45 Minuten bereit.",
          "showerTitle": "Vor der Nutzung duschen",
          "shower": "Körper waschen und abtrocknen – verbessert Hygiene und Wärmeaufnahme.",
          "towelTitle": "Handtuch verwenden",
          "towel": "Immer auf einem Handtuch sitzen – auch mit den Füßen.",
          "durationTitle": "Jeweils 10–15 Minuten saunieren",
          "duration": "Auf den Körper hören und reichlich Wasser trinken.",
          "coolTitle": "Danach abkühlen",
          "cool": "Duschen oder nach draußen gehen – das stärkt das Wohlbefinden."
        },
        "donts": {
          "title": "Was Sie nicht tun dürfen",
          "waterTitle": "Keine großen Wassermengen auf den Ofen gießen",
          "water": "Eine kleine Menge ist okay. Zu viel kann den Ofen beschädigen oder das Sicherheitssystem auslösen.",
          "alcoholTitle": "Kein Alkohol vor oder während der Nutzung",
          "alcohol": "Alkohol ist verboten – er kann in heißer Umgebung lebensgefährlich sein.",
          "foodTitle": "Keine Speisen oder Getränke",
          "childrenTitle": "Keine Kinder ohne Aufsicht",
          "children": "Nur kurze Nutzung und immer unter Aufsicht.",
          "oilsTitle": "Keine Öle oder Duftsteine",
          "oils": "Kann den Ofen beschädigen und allergische Reaktionen auslösen."
        },
        "safety": {
          "title": "Wichtige Sicherheitsregeln",
          "off": "Ofen nach der Nutzung immer ausschalten – rechten Knopf auf '0' drehen.",
          "health": "Sauna nicht nutzen, wenn Sie krank, schwanger oder Träger eines Herzschrittmachers sind.",
          "storage": "Sauna niemals als Lagerraum verwenden.",
          "air": "Lufteinlässe am Ofen frei halten.",
          "leave": "Sauna sofort verlassen, wenn Sie sich unwohl fühlen.",
          "water": "Vor und nach der Nutzung Wasser trinken, um Dehydrierung zu vermeiden."
        }
      },
      "manual": {
        "during": {
          "wifi": {
            "title": "Wi-Fi",
            "name": "Name: HabibiHytten",
            "password": "Passwort: Dolma3000",
            "speed": "Geschwindigkeit: bis zu 1000/1000 Mbit",
            "coverage": "Abdeckung im ganzen Haus und auch draußen"
          },
          "espresso": {
            "title": "Espressomaschine",
            "beans": "Kaffeebohnen inklusive.",
            "clean": "Nach jeder Tasse Kaffee Start drücken, um zu reinigen.",
            "empty": "Abwasser und Kaffeesatz regelmäßig leeren und den Wassertank mit sauberem Wasser füllen."
          },
          "foldingDoor": {
            "title": "Falttür",
            "body": "Die große Tür zum Pool kann in 5 Teilen geöffnet werden. Bitte langsam und vorsichtig öffnen. Schäden liegen in Ihrer Verantwortung."
          },
          "access": {
            "title": "Zutritt verboten",
            "shed": "Schuppen",
            "annex": "Anbau",
            "activityRoomTechnical": "Abgeschlossener Technikbereich im Aktivitätsraum"
          },
          "smoking": {
            "title": "Rauchen",
            "body": "Rauchen ist drinnen und auf der überdachten Terrasse verboten. Bitte rauchen Sie draußen."
          },
          "pool": {
            "title": "Pool",
            "body": "In der Sommersaison geöffnet"
          },
          "tv": {
            "title": "Smart TV",
            "streaming": "Lieblings-Streamingdienste herunterladen und einloggen",
            "cast": "Vom Telefon per Chromecast streamen"
          },
          "washer": {
            "title": "Waschmaschine und Trockner",
            "free": "Kann frei genutzt werden",
            "program": "Gewünschtes Programm einstellen und entspannen",
            "water": "Bitte Wasserbehälter des Trockners leeren"
          },
          "ev": {
            "title": "Elektroauto",
            "body": "Sie können Ihr Elektroauto frei anschließen. Beachten Sie, dass die Ladestation bei Ankunft ausgeschaltet sein kann."
          },
          "safety": {
            "title": "Sicherheit",
            "sensors": "Fenster und Außentüren haben Sensoren, damit wir sehen können, ob etwas offen ist.",
            "temp": "Temperaturüberwachung innen, außen, Sauna, Pool und Whirlpool",
            "video": "Schuppen und Anbau werden videoüberwacht"
          }
        },
        "after": {
          "tidying": {
            "title": "Aufräumen",
            "house": "Haus und Garten vollständig aufräumen",
            "packed": "Doppelt prüfen, ob alles eingepackt ist"
          },
          "dishwasher": {
            "title": "Geschirrspüler",
            "body": "Alles abwaschen und den Geschirrspüler leeren"
          },
          "espresso": {
            "title": "Espressomaschine",
            "waste": "Behälter mit Kaffeesatz leeren",
            "water": "Wassertank leeren",
            "tray": "Tropfschale leeren"
          },
          "trash": {
            "title": "Abfall",
            "sort": "Abfall sammeln, sortieren und draußen in die Behälter werfen",
            "bottles": "Leere Wein- und Spirituosenflaschen in den Abfallcontainer werfen"
          },
          "lights": {
            "title": "Licht",
            "body": "Alle Beleuchtung ausschalten, auch draußen"
          },
          "outdoor": {
            "title": "Gartenmöbel",
            "body": "Gartenmöbel so zurückstellen, wie sie bei Ankunft standen"
          },
          "grill": {
            "title": "Grill",
            "body": "Grill gereinigt und abgedeckt hinterlassen"
          },
          "hotTub": {
            "title": "Whirlpool",
            "body": "Lassen Sie den Whirlpool nach der Nutzung so, wie er ist. Das Wasser kann im Whirlpool bleiben."
          },
          "activityRoom": {
            "title": "Aktivitätsraum",
            "accessories": "Legen Sie alles Spielzubehör zurück an seinen Platz.",
            "tabletop": "Legen Sie zuerst die Tischtennis-/normale Tischplatte wieder auf und danach vor dem Verlassen die Tischdecke oben auf den Tisch.",
            "chairs": "Klappen Sie die Klappstühle zusammen und hinterlassen Sie sie wie bei der Ankunft.",
            "fridge": "Leeren Sie den Kühlschrank von Ihren eigenen Sachen.",
            "power": "Schalten Sie Projektor, Licht und Geräte aus, die nicht eingeschaltet bleiben sollen."
          },
          "lock": {
            "title": "Abschließen",
            "windows": "Alle Fenster schließen",
            "key": "Tür abschließen und Schlüssel in den Schlüsselkasten legen"
          }
        }
      },
      "checkInOut": {
        "el": "Position des Stromzählers",
        "elAlt": "Position des Stromzählers",
        "elLocation": "Position: Rechts von der Haustür. Bitte für das Foto den Blitz verwenden.",
        "water": "Position des Wasserzählers (Haus)",
        "waterAlt": "Wasserzähler im Haus",
        "waterLocation": "Position: Rechts im Technikschrank. Öffnen Sie die Schiebetür im Eingangsbereich.",
        "poolWater": "Position des Wasserzählers (Pool)",
        "poolWaterAlt": "Wasserzähler am Pool",
        "poolWaterReadingAlt": "Ablesung des Pool-Wasserzählers",
        "poolWaterLocation": "Position: Im Schuppen befindet sich der Wasserzähler in der linken Ecke. Bitte achten Sie auf die Pooltechnik."
      },
      "practical": {
        "coffee": {
          "title": "Kaffeemaschine",
          "body": "Die Kaffeemaschine muss nach Gebrauch regelmäßig von Abwasser und Kaffeesatz geleert werden. Den Tank mit sauberem Wasser füllen. Kaffeebohnen sind inklusive – Nachfüllungen gehen auf eigene Rechnung.",
          "manual": "Anleitung hier ansehen"
        },
        "sofa": {
          "title": "Schlafsofa",
          "body": "So benutzen Sie das Schlafsofa – sehen Sie das Video unten:",
          "fallback": "Ihr Browser unterstützt das Video nicht."
        },
        "security": {
          "title": "Überwachung und Alarme",
          "cameras": "Kameras überwachen Pooltechnikraum, Anbau und Schuppen",
          "shell": "Außenhautsicherung an allen Fenstern und Türen, inkl. Außentüren",
          "smoke": "Rauch- und CO-Alarm benachrichtigt Gastgeber bei Auslösung",
          "temp": "Pool, Whirlpool, Sauna und Außentemperatur werden überwacht – sichtbar auf dem Bildschirm beim TV"
        },
        "sonos": {
          "title": "Sonos-Lautsprecher",
          "iphone": "iPhone: AirPlay verwenden und Sonos in der Lautsprecherliste wählen.",
          "android": "Android: Sonos-App oder Bluetooth verwenden, falls unterstützt."
        },
        "stove": {
          "title": "Kochfeld-Fehler",
          "body": "Hinweis: Wenn das Kochfeld “LO” zeigt, bedeutet das \"gesperrt\". Startknopf 3 Sekunden gedrückt halten, um zu entsperren."
        },
        "games": {
          "title": "Brettspiele & PlayStation",
          "cupboard": "Brettspiele befinden sich im Schrank über dem Kühlschrank.",
          "purchases": "Sie dürfen unsere Spiele nutzen oder eigene herunterladen – wir übernehmen jedoch keine Kosten für Käufe."
        }
      }
    },
    "checkInOutPage": {
      "title": "Check-in und Check-out",
      "desktopTitle": "Check-in und Check-out",
      "description": "Mobile Seite zum Ablesen von Strom- und Wasserzählern",
      "mobileOnly": "– Diese Seite ist nur über ein Mobiltelefon zugänglich",
      "unknownError": "Unbekannter Fehler",
      "fallbackError": "Etwas ist schiefgelaufen.",
      "meterLocationPrompt": {
        "eyebrow": "Zählerguide",
        "text": "Finden Sie die Zähler, bevor Sie die Werte eintragen. Wir empfehlen, auf die Upload-Schaltfläche zu tippen und jedes Foto direkt von dort aufzunehmen.",
        "button": "Standorte anzeigen"
      },
      "fields": {
        "name": {
          "label": "Name",
          "placeholder": "Name des Mieters"
        },
        "keycode": {
          "label": "Schlüsselkasten-Code",
          "placeholder": "Code eingeben"
        },
        "checkType": {
          "label": "Check-in oder Check-out",
          "checkin": "Check-in",
          "checkout": "Check-out"
        },
        "confirmEmail": "E-Mail bestätigen",
        "elReading": "Stromzählerstand",
        "elReadingDescription": "Verwenden Sie Blitz für das Foto des Stromzählers, damit die Zahlen gut lesbar sind.",
        "waterHouse": "Wasser (Haus)",
        "waterHouseExamplePrefix": "Beispiel:",
        "waterHouseExampleSuffix": ". Die weißen Zahlen stehen vor dem Komma, die roten Zahlen nach dem Komma.",
        "waterPool": "Wasser (Pool)",
        "meterImages": {
          "label": "Foto der Ablesung",
          "description": "Sie können mehr als ein Foto hochladen. Bestätigen Sie jede Ablesung mit klaren Fotos und verwenden Sie beim Stromzähler den Blitz."
        },
        "comment": {
          "label": "Kommentar",
          "placeholder": "Schreiben Sie hier Ihren Kommentar"
        },
        "consent": "Ich stimme zu, dass meine Angaben zur Bearbeitung meiner Anfrage verwendet werden dürfen."
      },
      "submit": "Ablesung senden",
      "sending": "Fotos werden hochgeladen und die Ablesung wird gesendet. Das kann einen Moment dauern...",
      "success": "Danke! Ihre Ablesung wurde gesendet.",
      "progress": {
        "compressing": "Fotos werden vorbereitet",
        "ready": "Fotos bereit zum Hochladen",
        "readyOriginal": "Fotos bereit zum Hochladen",
        "originalSize": "Ausgewählte Größe: {{size}}",
        "uploading": "Ablesung wird hochgeladen",
        "uploadSize": "Upload-Größe: {{size}}"
      },
      "errors": {
        "rateLimited": "Es wurden zu viele Ablesungen in kurzer Zeit gesendet. Bitte warten Sie einen Moment und versuchen Sie es erneut.",
        "tooFast": "Bitte prüfen Sie das Formular noch einmal und senden Sie es in einem Moment erneut.",
        "formExpired": "Diese Formularsitzung ist abgelaufen. Bitte laden Sie die Seite neu und senden Sie die Ablesung erneut.",
        "invalidFileType": "Bitte laden Sie nur Bilddateien hoch. Fotos von Ihrer Handykamera werden akzeptiert.",
        "fileTooLarge": "Ein oder mehrere Fotos sind zu groß. Bitte öffnen Sie jedes Zählerfoto, machen Sie einen Screenshot und laden Sie stattdessen die Screenshots hoch.",
        "fileTooLargeInline": "Dieses Foto ist zu groß. Bitte machen Sie einen Screenshot davon und fügen Sie stattdessen den Screenshot hinzu.",
        "fileStillTooLargeInline": "Dieses Foto ist nach der Vorbereitung immer noch zu groß. Bitte machen Sie einen Screenshot davon und fügen Sie stattdessen den Screenshot hinzu.",
        "totalUploadTooLarge": "Die Fotos sind zu groß. Bitte laden Sie stattdessen Screenshots der Zählerfotos hoch.",
        "tooManyFiles": "Es wurden zu viele Fotos hochgeladen. Bitte laden Sie nur die benötigten Zählerfotos hoch.",
        "tooManyFields": "Es wurden zu viele Informationen gesendet. Bitte laden Sie die Seite neu und versuchen Sie es erneut.",
        "missingFiles": "Bitte laden Sie mindestens ein Foto der Zählerablesung hoch.",
        "validation": "Bitte prüfen Sie die Pflichtfelder und stellen Sie sicher, dass die Zählerstände korrekt eingetragen sind.",
        "mail": "Ihre Ablesung wurde gespeichert, aber die E-Mail konnte nicht automatisch gesendet werden. Wir können sie trotzdem im Admin-System sehen.",
        "network": "Die Verbindung wurde unterbrochen, bevor die Ablesung gesendet werden konnte. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
        "serverResponse": "Die Ablesung konnte nicht gesendet werden, weil der Server einen unlesbaren Fehler zurückgegeben hat. Bitte versuchen Sie es erneut mit Screenshots der Zählerfotos."
      },
      "errorLabel": "Fehler:",
      "errorTitle": "Die Ablesung konnte nicht gesendet werden"
    },
    "manualPage": {
      "title": "Anleitung 🧭 Fyrrehaven 61",
      "description": "Wichtige Infos für Ihren Aufenthalt: Stromzähler, Wasserzähler, Zugang, Regeln und mehr.",
      "imageAlt": "Anleitungsbild",
      "hero": {
        "title": "Danke, dass Sie unser Ferienhaus gewählt haben!",
        "subtitle": "Hier finden Sie praktische Informationen dazu, wie Sie das Haus nutzen und behandeln. Folgen Sie uns gerne in den sozialen Medien und teilen Sie Ihre Erfahrung mit #fyrrehaven61."
      },
      "quickLinks": {
        "pool": "Pool",
        "hotTub": "Whirlpool",
        "sauna": "Sauna"
      },
      "notice": {
        "label": "WICHTIG!",
        "body": "Es liegt in Ihrer Verantwortung, Strom- und Wasserzähler abzulesen. Wenn Sie dies vergessen, kann mehr als Ihr tatsächlicher Verbrauch berechnet werden.",
        "meterLinkIntro": "Die Zählerablesung muss beim Check-in und Check-out über unsere Website erfolgen. Den QR-Code finden Sie am Eingang oder ",
        "meterLink": "hier",
        "electricity": "Stromzähler ablesen",
        "houseWater": "Wasserzähler im Haus ablesen",
        "poolWater": "Pool-Wasserzähler im Schuppen ablesen"
      },
      "stayTitle": "Anleitung für Ihren Aufenthalt",
      "afterTitle": "Nach Ihrem Aufenthalt"
    },
    "poolPage": {
      "seo": {
        "title": "Pool – Mai 2026",
        "description": "So benutzen und öffnen Sie den Pool am Ferienhaus."
      },
      "title": "POOL",
      "subtitle": "– Mai 2026",
      "warning": {
        "title": "Um Strom und Wärme zu sparen, empfehlen wir an kalten Tagen mit geschlossener Poolabdeckung zu baden",
        "body": "Bitte lassen Sie die gesamte Poolabdeckung nicht über längere Zeit geöffnet. Der Pool ist über die eingebaute Tür zugänglich."
      },
      "rules": {
        "title": "Regeln und Nutzung",
        "temperature": "Die Pooltemperatur liegt bei ca. 28 Grad Celsius",
        "depth": "1,5 Meter tief",
        "automatic": "Der Pool wird automatisch mit Wasser und Chemikalien befüllt",
        "noDiving": "Nicht hineinspringen",
        "tech": "Die gesamte Technik befindet sich im Schuppen und kann per App gesteuert werden. Bitte kontaktieren Sie uns bei Problemen!"
      },
      "preparation": {
        "title": "Vorbereitung",
        "unlock": "Benutzen Sie den “Enten”-Schlüssel, um den Pool zu entriegeln (siehe Bilder)",
        "open": "Die Poolabdeckung kann nun aufgeschoben oder die Tür geöffnet werden",
        "cover": "Poolabdeckung entfernen und in den Schuppen legen (gefaltet oder zusammengerollt)"
      }
    },
    "activityRoomPage": {
      "seo": {
        "title": "Aktivitätsraum – Fyrrehaven 61",
        "description": "Anleitung zur Nutzung des Aktivitätsraums mit Billard, Tischtennis, Airhockey, Darts, Projektor, Kühlschrank und Sicherheitsregeln."
      },
      "title": "Aktivitätsraum",
      "subtitle": "Hier können Sie Billard, Tischtennis, Airhockey und Darts spielen oder Filme über den Projektor mit Chromecast und Google TV ansehen. Klappstühle befinden sich im Raum und können als zusätzliche Sitzplätze genutzt werden.",
      "fridge": {
        "title": "Kühlschrank bei Ankunft",
        "body": "Der Kühlschrank muss bei Ankunft eingeschaltet werden. Nutzen Sie den Schalter neben dem Kühlschrank und geben Sie ihm etwas Zeit, kalt zu werden."
      },
      "table": {
        "title": "Nutzung des Multispieltisches",
        "intro": "Der Multispieltisch wird für Billard, Airhockey und Tischtennis genutzt. Er ist schwer, wechseln Sie das Spiel daher langsam und vorsichtig.",
        "howToTitle": "So wechseln Sie das Spiel",
        "steps": [
          "Entfernen Sie immer Kugeln, Queues, Schläger, Pucks und Netz vom Tisch, bevor Sie das Spiel wechseln.",
          "Der Tisch hat Spezialrollen mit Bremsen. Wenn Sie den Tisch verschieben, müssen alle vier Rollen vor der Nutzung wieder festgestellt werden.",
          "Wechseln Sie zwischen Billard und Airhockey, indem Sie die Halterungen entriegeln, die Tischplatte vorsichtig drehen und die Halterungen vor dem Spielen wieder verriegeln.",
          "Für Tischtennis werden die Tischtennisplatten oben auf den Tisch gelegt und das Netz in der Mitte befestigt.",
          "Wenn der Tisch als normaler Tisch genutzt wird, legen Sie zuerst die Tischdecke darauf. Verschüttetes kann sonst nach unten gelangen und die Spielfläche darunter beschädigen.",
          "Verwenden Sie nur das Zubehör, das zum jeweiligen Spiel gehört, und legen Sie nach der Nutzung alles zurück."
        ],
        "wheelLockImageAlt": "Nahaufnahme der Bremse an einer Rolle des Multispieltisches",
        "wheelLockCaption": "Jede der vier Rollen hat eine Bremse. Stellen Sie alle Rollen fest, bevor Sie spielen.",
        "bracketsImageAlt": "Nahaufnahme der roten Tischhalterungen am Multispieltisch",
        "bracketsCaption": "Öffnen Sie die Tischhalterungen vor dem Drehen der Tischplatte und verriegeln Sie sie vor der Nutzung wieder.",
        "safetyTitle": "Nutzungs- und Sicherheitshinweise",
        "safety": [
          "Der Tisch darf nur genutzt werden, wenn alle vier Verriegelungen geschlossen sind und den Tisch stützen.",
          "Der Tisch darf nur genutzt werden, wenn alle vier Rollenbremsen festgestellt sind.",
          "Beim Drehen des Tisches müssen alle vier Verriegelungen vollständig geöffnet sein. Ist eine Verriegelung geschlossen, kann sie brechen.",
          "Drehen Sie den Tisch immer langsam und mit größtmöglicher Vorsicht.",
          "Lehnen Sie sich niemals an den Tisch und setzen Sie sich niemals auf die Kanten.",
          "Stellen Sie immer sicher, dass die Poolkugeln aus dem Tisch entfernt sind und das Airhockey-Stromkabel zurückgezogen ist, bevor Sie den Tisch drehen.",
          "Kinder müssen beim Spielen oder Drehen des Tisches immer von einem Erwachsenen begleitet werden.",
          "Nur für den Innenbereich."
        ]
      },
      "airHockey": {
        "title": "Airhockey",
        "steps": [
          "Stecken Sie das Airhockey-Stromkabel in eine Steckdose, bevor Sie spielen.",
          "Verwenden Sie nur die passenden Pucks und Schieber.",
          "Ziehen Sie das Stromkabel wieder heraus und legen Sie es zurück, bevor der Tisch zu einem anderen Spiel gedreht wird."
        ]
      },
      "dart": {
        "title": "Darts",
        "steps": [
          "Die Dartscheibe befindet sich über dem Kühlschrank.",
          "Verwenden Sie Dartpfeile nur an der Dartscheibe.",
          "Rund um die Dartscheibe befinden sich Schutzpolster, falls ein Pfeil daneben geht. Prüfen Sie trotzdem immer den Bereich um die Scheibe, bevor Sie werfen.",
          "Kinder dürfen nur zusammen mit einem Erwachsenen Darts spielen."
        ]
      },
      "projector": {
        "title": "Projektor, Chromecast und Google TV",
        "steps": [
          "Schalten Sie den Projektor ein.",
          "Schalten Sie die Soundbar manuell ein, wenn sie ausgeschaltet ist. Sie leuchtet rot, wenn sie ausgeschaltet ist, und verbindet sich danach automatisch.",
          "Streamen Sie von Ihrem Telefon oder melden Sie sich über Google TV bei Ihrem eigenen Streamingdienst an.",
          "Melden Sie sich von Streamingdiensten ab, wenn Sie fertig sind.",
          "Schalten Sie vor dem Verlassen des Raums nur den Projektor aus. Die Soundbar schaltet sich zusammen mit dem Projektor aus."
        ]
      },
      "closedArea": {
        "title": "Geschlossener Technikbereich",
        "body": "Der Bereich mit Poolmotor, Chemikalien und technischer Ausrüstung ist abgeschlossen und darf nicht geöffnet werden. Der abgeschlossene Bereich wird videoüberwacht."
      },
      "leaving": {
        "title": "Bevor Sie den Raum verlassen",
        "steps": [
          "Legen Sie alles Spielzubehör zurück an seinen Platz.",
          "Legen Sie zuerst die Tischtennis-/normale Tischplatte wieder auf und danach vor dem Verlassen die Tischdecke oben auf den Tisch.",
          "Klappen Sie die Klappstühle zusammen und hinterlassen Sie sie wie bei der Ankunft.",
          "Leeren Sie den Kühlschrank von Ihren eigenen Sachen.",
          "Schalten Sie Projektor, Licht und Geräte aus, die nicht eingeschaltet bleiben sollen."
        ]
      }
    },
    "welcome": {
      "title": "Willkommen – Fyrrehaven 61",
      "hero": {
        "title": "Willkommen bei Fyrrehaven 61!",
        "subtitle": "Wir freuen uns, Sie in einer schönen und entspannten Umgebung willkommen zu heißen – hier kommen ein paar praktische Infos!"
      },
      "description": "Willkommen zu Ihrem Aufenthalt in Fyrrehaven 61. Hier finden Sie praktische Informationen zum Haus, Pool, zur Sauna und vielem mehr.",
      "imageAlt": "Willkommensbild",
      "intro": "Hier finden Sie eine Anleitung für Ihren Aufenthalt bei uns. Sie hilft hoffentlich dabei, Ihre Erfahrung genau richtig zu machen. Wenn Sie hier oder an anderer Stelle auf der Website keine Antwort finden, hören wir natürlich sehr gerne von Ihnen.",
      "manualCta": "Zur Anleitung",
      "practicalInfoCta": "Praktische Informationen",
      "arrival": "Wenn Sie an der Adresse Fyrrehaven 61, 8585 Glesborg, ankommen, gibt es Platz für 6 Autos in der Einfahrt. Dort finden Sie auch eine Ladestation für Elektroautos. Sollte sie wider Erwarten ausgeschaltet sein, können Sie auf der Website nachsehen, wie sie eingeschaltet wird.",
      "meterIntro": "Machen Sie bitte zuerst bei Ankunft ein Foto vom Stromkasten und den Wasserzählern – und erneut vor der Abreise – und senden Sie es uns zur Abrechnung des Verbrauchs.",
      "electricityMeter": "Der Stromzähler befindet sich rechts von der Haustür auf der überdachten Terrasse.",
      "waterMeters": "Wasserzähler: Einer befindet sich im Technikschrank im Eingangsbereich (ganzjährig genutzt), ein weiterer bei der Pooltechnik im Aktivitätsraum (nur in der Poolsaison genutzt).",
      "keyBox": "Den Schlüsselkasten finden Sie rechts von der Haustür. Der Code wird 1 Stunde vor Ankunft per E-Mail oder Airbnb-Nachricht gesendet.",
      "guideIntro": "Wichtig! Bevor Sie Pool, Sauna und Whirlpool benutzen, lesen Sie bitte die Anleitung:",
      "pool": "Pool",
      "sauna": "Sauna",
      "hotTub": "Whirlpool",
      "hotTubNote": "Hinweis: Sie müssen kein eigenes Brennholz für den Whirlpool mitbringen, da er elektrisch beheizt wird.",
      "smoking": "Rauchen ist im Haus verboten. Wenn Sie draußen rauchen, sammeln Sie bitte Ihre Zigarettenstummel auf.",
      "pets": "Haustiere sind nicht erlaubt. Bitte gehen Sie sorgsam mit unseren Dingen um und geben Sie uns Bescheid, falls etwas kaputtgeht.",
      "departureIntro": "Vor der Abreise folgen Sie bitte der Checkliste auf der Website:",
      "departureCta": "Checkliste für die Abreise",
      "hope": "Wir hoffen, Sie haben ein einzigartiges und wunderbares Erlebnis!",
      "share": "Teilen Sie Ihre Erfahrung gerne mit #fyrrehaven61 in den sozialen Medien.",
      "addressTitle": "Adresse hier finden:",
      "mapAlt": "Karte zum Ferienhaus",
      "googleMaps": "Google Maps",
      "appleMaps": "Apple Karten"
    }
  },
  "navigation": {
    "public": {
      "house": "Das Haus",
      "area": "Umgebung",
      "gallery": "Galerie",
      "contact": "Kontakt"
    },
    "guest": {
      "welcome": "Willkommen",
      "manual": "Benutzerhandbuch",
      "activityRoom": "Aktivitätsraum",
      "pool": "Pool",
      "sauna": "Sauna",
      "spa": "Whirlpool",
      "practicalInfo": "Praktische Infos"
    },
    "actions": {
      "book": "Buchen",
      "bookNow": "Jetzt buchen",
      "changeAppearance": "Darstellung wechseln",
      "toggleAppearance": "Zwischen hellem und dunklem Modus wechseln",
      "changeLanguage": "Sprache wechseln",
      "closeMenu": "Menü schließen",
      "openMenu": "Menü öffnen",
      "currentLanguage": "Aktuelle Sprache",
      "currentAppearance": "Aktuelle Darstellung"
    },
    "appearance": {
      "system": "System",
      "light": "Hell",
      "dark": "Dunkel"
    },
    "menu": {
      "main": "Hauptnavigation",
      "mobile": "Mobiles Menü",
      "title": "Menü",
      "description": "Hauptnavigation für die Seite"
    }
  },
  "footer": {
    "tagline": "Ferienhaus bei Wald & Strand",
    "superhostAria": "Unser Airbnb-Profil ansehen (Superhost)",
    "sections": {
      "explore": "Entdecken",
      "contactBooking": "Kontakt & Buchung",
      "practical": "Praktisch"
    },
    "links": {
      "house": "Das Haus",
      "area": "Umgebung",
      "gallery": "Galerie",
      "bookAirbnb": "Auf Airbnb buchen",
      "contact": "Kontakt aufnehmen",
      "houseRules": "Hausregeln",
      "faq": "Häufig gestellte Fragen",
      "activityRoom": "Aktivitätsraum",
      "extraServices": "Zusatzleistungen",
      "privacy": "Datenschutz",
      "cookies": "Cookie-Einstellungen",
      "fees": "Gebühren"
    },
    "socialAria": "Soziale Medien",
    "messengerAria": "Schreiben Sie uns auf Messenger",
    "messengerDismissAria": "Messenger-Schaltfläche ausblenden",
    "guestPageAria": "Gästeseite",
    "rights": "Alle Rechte vorbehalten."
  },
  "seo": {
    "home": {
      "title": "Ferienhaus Fjellerup | Fyrrehaven 61",
      "description": "Familienfreundliches Ferienhaus auf Djursland mit beheiztem Pool (Mai–Okt.), Whirlpool, Sauna und Aktivitätsraum. Platz für 10 nahe Fjellerup Strand.",
      "keywords": [
        "Ferienhaus Dänemark",
        "Sommerhaus Fjellerup",
        "Familienferien Dänemark",
        "Ferienhaus für deutsche Gäste",
        "beheizter Pool Ferienhaus",
        "Whirlpool Ferienhaus",
        "Sauna Ferienhaus",
        "Ferienhaus mit Aktivitätsraum",
        "Ferienhaus mit Billard",
        "Djursland Ferienhaus",
        "Fyrrehaven 61"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Fyrrehaven 61 Ferienhaus bei Fjellerup Strand",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "house": {
      "title": "Das Haus | Fyrrehaven 61",
      "description": "Ferienhaus für 10 Personen auf Djursland mit beheiztem Außenpool (1. Mai–1. Okt.), elektrischem Whirlpool, Sauna und Aktivitätsraum mit Billard, Tischtennis, Airhockey, Darts und Projektor. Familienfreundlich nahe Wald und Strand.",
      "keywords": [
        "Ferienhaus Fjellerup",
        "beheizter Außenpool",
        "Whirlpool",
        "Sauna",
        "Aktivitätsraum",
        "Billard",
        "Airhockey",
        "familienfreundlich",
        "10 Personen",
        "Djursland Urlaub",
        "Fyrrehaven 61"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/IMG_3724.jpg",
      "imageAlt": "Außenpoolbereich beim Ferienhaus",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "area": {
      "title": "Region Fjellerup | Fyrrehaven 61",
      "description": "Entdecken Sie Fjellerup und Djursland von Fyrrehaven 61 aus: Wanderwege am Haus, Strand in Geh- und Fahrraddistanz und familienfreundliche Attraktionen wie Djurs Sommerland, Mols Bjerge und das Kattegat Center. Sehen Sie die Karte und unsere besten lokalen Tipps.",
      "keywords": [
        "Fjellerup",
        "Djursland",
        "Wald und Strand",
        "Familienattraktionen",
        "Djurs Sommerland",
        "Mols Bjerge",
        "Kattegatcentret",
        "Grenaa",
        "Ebeltoft",
        "Wanderwege",
        "Radwege",
        "Fyrrehaven 61"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Wald und Strand bei Fjellerup",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "gallery": {
      "title": "Galerie | Fyrrehaven 61",
      "description": "Sehen Sie Fotos vom Wohnzimmer, Essbereich, Schlafzimmern, Dachboden und Aktivitätsraum – plus dem beheizten Außenpool (1. Mai–1. Okt), elektrischem Whirlpool, Elektro-Sauna und dem nahegelegenen Wald und Strand bei Fjellerup. Gewinnen Sie einen echten Eindruck.",
      "keywords": [
        "Fyrrehaven 61",
        "Galerie",
        "Ferienhaus Fotos",
        "beheizter Außenpool",
        "Whirlpool",
        "Sauna",
        "Aktivitätsraum",
        "Fjellerup",
        "Djursland",
        "Wald und Strand",
        "Familienurlaub"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Galerie-Cover-Collage",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "faq": {
      "title": "FAQ | Fyrrehaven 61",
      "description": "Antworten zu Check-in, Pool & Wellness, Bettwäsche, Zahlung, Hausregeln und mehr.",
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "FAQ zu Fyrrehaven 61",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "contact": {
      "title": "Kontakt | Fyrrehaven 61",
      "description": "Haben Sie Fragen zu Daten, Preisen, Ausstattung oder besonderen Wünschen? Senden Sie uns eine Nachricht über das Formular – wir antworten in der Regel am selben Tag. Die Kommunikation erfolgt per E-Mail und Ihre Daten werden gemäß unserer Datenschutzerklärung verarbeitet.",
      "keywords": [
        "Kontakt",
        "Fyrrehaven 61",
        "Ferienhaus Fjellerup",
        "Buchungsfragen",
        "Ferienhausvermietung",
        "familienfreundliches Ferienhaus",
        "Pool Whirlpool Sauna",
        "Djursland Dänemark",
        "direkt buchen",
        "Airbnb Kontakt"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Die Familie hinter dem Haus",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "book": {
      "title": "Buchung | Fyrrehaven 61",
      "description": "Buchen Sie direkt bei den Gastgebern oder über Airbnb. Beheizter Außenpool (1. Mai–1. Okt.), Aktivitätsraum, Platz für 10 Gäste und familienfreundlich nahe Wald und Strand. Wir antworten normalerweise innerhalb von 1 Stunde. Strom 4 DKK/kWh und Wasser 80 DKK/m³ werden nach dem Aufenthalt abgerechnet.",
      "keywords": [
        "Ferienhaus Buchung",
        "Fyrrehaven 61 Buchung",
        "Ferienhaus Fjellerup",
        "beheizter Außenpool",
        "Whirlpool",
        "Sauna",
        "Aktivitätsraum",
        "familienfreundliche Unterkunft",
        "direkt buchen",
        "Airbnb Fjellerup",
        "Djursland Ferienhaus"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Buchung des Ferienhauses bei Fjellerup",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "cookies": {
      "title": "Cookies | Fyrrehaven 61",
      "description": "Lesen Sie mehr über unsere Verwendung von Cookies und verwalten Sie Ihre Auswahl.",
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Cookies"
    },
    "fees": {
      "title": "Gebühren | Fyrrehaven 61",
      "description": "Sehen Sie die aktuelle Gebührenübersicht für Fyrrehaven 61: Buchungsregeln, Reinigung, späten Check-out und besondere Situationen. Strom (4 DKK/kWh) und Wasser (80 DKK/m³) werden nach Verbrauch abgerechnet. Keine Partys/Haustiere. Pool geöffnet 1.5.–1.10.",
      "keywords": [
        "Ferienhaus Gebühren",
        "Gebührenübersicht",
        "Reinigungsgebühr",
        "Stromverbrauch Preis",
        "Wasserverbrauch Preis",
        "später Check-out Gebühr",
        "Schäden und Ersatz",
        "Fyrrehaven 61 Preise"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Übersicht der Gebühren",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "extraServices": {
      "title": "Zusatzleistungen | Fyrrehaven 61",
      "description": "Sehen Sie Zusatzleistungen für den Aufenthalt in Fyrrehaven 61: Bettwaren, Bettwäsche, Handtücher, Pakete, Befüllung des Badezubers, Hochstuhl und Babybett.",
      "keywords": [
        "Zusatzleistungen",
        "Ferienhaus Extras",
        "Bettwäsche Ferienhaus",
        "Handtücher Ferienhaus",
        "Badezuber Befüllung",
        "Babybett",
        "Hochstuhl",
        "Fyrrehaven 61"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Zusatzleistungen für den Aufenthalt",
      "robots": {
        "index": true,
        "follow": true,
        "noarchive": true
      }
    },
    "privacy": {
      "title": "Datenschutz | Fyrrehaven 61",
      "description": "Erfahren Sie, wie wir personenbezogene Daten verarbeiten, wenn Sie uns kontaktieren oder Fyrrehaven 61 buchen. Wir speichern Anfragen als E-Mail bei Simply, setzen standardmäßig nur notwendige Cookies und respektieren Ihre DSGVO-Rechte.",
      "keywords": [
        "Datenschutzerklärung",
        "DSGVO",
        "personenbezogene Daten",
        "Datenverarbeitung",
        "Verantwortlicher",
        "Auftragsverarbeiter",
        "DSGVO Rechte",
        "Cookie-Richtlinie",
        "Buchung personenbezogene Daten",
        "Fyrrehaven 61 Datenschutz",
        "E-Mail Speicherung",
        "Simply E-Mail-Anbieter"
      ],
      "image": "https://media.fyrrehaven-61.dk/wp-content/uploads/2025/09/ogimage2.jpg",
      "imageAlt": "Datenschutzerklärung",
      "robots": {
        "index": false,
        "follow": true,
        "noarchive": true
      }
    }
  },
  "house": {
    "jsonLd": {
      "outdoorPool": "Beheizter Außenpool",
      "poolSeason": "Geöffnet vom 1. Mai bis 1. Oktober",
      "hotTub": "Elektrischer Whirlpool",
      "sauna": "Elektrische Sauna",
      "activityRoom": "Aktivitätsraum mit Spielen und Projektor",
      "beachForest": "Nahe Strand & Wald"
    },
    "hero": {
      "title": "Das Haus – Platz für 10, Pool, Wellness & Aktivitätsraum",
      "subtitle": "4 Schlafzimmer + Galerie. Beheizter Außenpool (1. Mai–1. Okt.), elektrischer Whirlpool, Sauna und Aktivitätsraum.",
      "badges": [
        "10 Gäste",
        "4 Schlafzimmer",
        "2 Badezimmer",
        "Beheizter Außenpool",
        "Whirlpool",
        "Sauna",
        "Aktivitätsraum"
      ],
      "primaryCta": "Privat buchen",
      "secondaryCta": "Buchen | Airbnb",
      "imageAlt": "Außenpoolbereich beim Haus",
      "imageTitle": "Fyrrehaven 61 – Ferienhaus bei Fjellerup Strand"
    },
    "sleeping": {
      "title": "Schlafplätze & Grundriss",
      "bedsTitle": "Betten (Doppelbetten)",
      "beds": [
        "Insgesamt 4 Doppelbetten: 2× 180×200 cm und 2× 200×200 cm",
        "Jedes Doppelbett hat 2 Kissen (Faser 60×63/70) und 2 Faserdecken 135×200"
      ],
      "storageTitle": "Bettwäsche & Aufbewahrung",
      "storage": [
        "Bettwäsche kann auf Wunsch gemietet werden – sonst bitte selbst mitbringen",
        "Kommode mit Schubladen für Kleidung",
        "Spiegel",
        "Haken hinter der Tür",
        "2 Nachttischlampen"
      ]
    },
    "wellness": {
      "title": "Pool & Wellness",
      "poolTitle": "Außenpool",
      "pool": [
        "1,5 m tief",
        "3,5 m breit · 8 m lang",
        "Beheizt auf ca. 29 °C",
        "Saison: 1. Mai – 1. Oktober",
        "Dach/Überdachung kann an kalten oder windigen Tagen geschlossen werden",
        "Poolbeleuchtung (einschaltbar)",
        "Automatische Dosierung der Poolchemie"
      ],
      "hotTubTitle": "Elektrischer Whirlpool",
      "hotTub": [
        "Bis zu 6 Personen",
        "Elektrisch beheizt",
        "Massagefunktion und Beleuchtung",
        "Wasser wird mit dem Gartenschlauch eingefüllt – kann gegen Aufpreis vor Ankunft gefüllt werden"
      ],
      "saunaTitle": "Sauna",
      "sauna": [
        "Bis zu 8 Personen",
        "Innen- und Außenbeleuchtung",
        "Für Dampf vorsichtig Wasser auf den Ofen gießen"
      ]
    },
    "activityRoom": {
      "title": "Aktivitätsraum",
      "gamesTitle": "Spiele im Raum",
      "games": [
        "3-in-1-Tisch für Billard, Tischtennis und Airhockey",
        "Dartscheibe über dem Kühlschrank mit Schutzpolstern rundherum",
        "Airhockey benötigt Strom und muss vor der Nutzung an eine Steckdose angeschlossen werden"
      ],
      "movieTitle": "Filme & Aufenthalt",
      "movie": [
        "Projektor mit Chromecast und Google TV",
        "Bluetooth-Soundbar für den Filmton",
        "Klappstühle und zusätzlicher Platz für entspannte Abende"
      ]
    },
    "kitchenLiving": {
      "title": "Küche & Wohnen",
      "kitchenTitle": "Küche",
      "kitchen": [
        "Voll ausgestattete Küche: Kühl-/Gefrierschrank, Backofen, Mikrowelle",
        "Automatische Kaffeemaschine, Filterkaffee und French Press",
        "Mülltrennung"
      ],
      "livingTitle": "Wohnbereich & Unterhaltung",
      "living": [
        "Großer Esstisch mit Platz für 10 Personen",
        "Heller Raum mit Fenstern auf beiden Seiten",
        "TV-Bereich mit Sofa, Stühlen und 55-Zoll-TV",
        "Außenrutsche",
        "Trampolin",
        "PlayStation 4"
      ]
    }
  },
  "facilities": {
    "aria": "Ausstattung",
    "title": "Ausstattung – vollständige Liste",
    "intro": "Strom- und Wasserverbrauch werden nach dem Aufenthalt abgerechnet und per Banküberweisung bezahlt.",
    "categories": {
      "kitchen": {
        "title": "Küche",
        "bullets": [
          "Voll ausgestattete Küche",
          "Kühl-/Gefrierschrank, Backofen und Mikrowelle",
          "Automatische Kaffeemaschine, Filterkaffee und French Press",
          "Sodastream inkl. austauschbarer Patrone",
          "Geschirr für 10: Teller, Besteck, Gläser, Tassen, Champagner- und Weingläser",
          "Wasserkrüge und Eiswürfelform",
          "Mülltrennung",
          "Gasgrill"
        ]
      },
      "living": {
        "title": "Wohnen & Praktisches",
        "bullets": [
          "Großer Esstisch für 10 Personen",
          "55-Zoll-TV und PlayStation 4 im Wohnzimmer",
          "Fußbodenheizung im ganzen Haus · Klimaanlage",
          "Waschmaschine und Trockner",
          "Reisebett für Kinder (kostenlos vorab bestellen)",
          "Bügeleisen und Föhn",
          "E-Auto-Ladestation"
        ]
      },
      "activityRoom": {
        "title": "Aktivitätsraum",
        "bullets": [
          "3-in-1-Tisch für Billard, Tischtennis und Airhockey",
          "Dartscheibe über dem Kühlschrank mit Schutzpolstern rundherum",
          "Projektor mit Chromecast, Google TV und Bluetooth-Soundbar",
          "Klappstühle und kleiner Kühlschrank im Raum"
        ]
      },
      "outdoor": {
        "title": "Außenbereich",
        "bullets": [
          "Außenpool beheizt auf ca. 29 °C (1. Mai – 1. Oktober) mit Überdachung",
          "Elektrischer Whirlpool (bis zu 6 Pers.) mit Licht und Massage",
          "Elektrische Sauna (bis zu ca. 8 Pers.) – leichter Dampf durch Wasser auf den Steinen",
          "Trampolin sowie Schaukel/Spielturm mit Rutsche"
        ]
      },
      "checkin": {
        "title": "Check-in",
        "bullets": [
          "Selbst-Check-in über Schlüsselkasten (Code wird 1 Stunde vor Ankunft gesendet)",
          "Anreise 16:00 · Abreise 10:00",
          "Fotos von Strom- und Wasserzählern beim Check-in/out über die Website hochladen"
        ]
      },
      "rules": {
        "title": "Hausregeln",
        "bullets": [
          "Keine Partys",
          "Nichtraucherhaus (kein Rauchen im Innenbereich)",
          "Kein Zugang zu Annex und Schuppen",
          "Kein Aufenthalt im Pool-Technikraum"
        ]
      }
    }
  },
  "cookiesPage": {
    "consent": {
      "brandName": "Fyrrehaven 61",
      "title": "Wir verwenden Cookies",
      "description": "Wir verwenden notwendige Cookies, damit die Website funktioniert und Ihre Cookie-Einstellungen gespeichert werden.",
      "acceptAll": "OK",
      "rejectAll": "Ablehnen",
      "preferences": "Cookie-Einstellungen",
      "settingsTitle": "Cookie-Einstellungen",
      "close": "Schließen",
      "save": "Einstellungen speichern",
      "manageButton": "Cookie-Einstellungen verwalten",
      "footer": "Sie können Ihre Einwilligung jederzeit über die Cookie-Einstellungen ändern oder widerrufen."
    },
    "categories": {
      "necessary": {
        "title": "Notwendige Cookies",
        "label": "Notwendige",
        "description": "Erforderlich, damit die Website funktioniert. Diese Cookies können nicht deaktiviert werden.",
        "tableCaption": "Notwendige Cookies"
      },
      "statistics": {
        "title": "Statistik-Cookies",
        "label": "Statistik",
        "description": "Optionale Analyse-Cookies, die uns helfen zu verstehen, wie die Website genutzt wird. Sie werden nur geladen, wenn Sie zustimmen.",
        "tableCaption": "Statistik-Cookies"
      }
    },
    "preferences": {
      "introTitle": "Cookie-Einstellungen",
      "introDescription": "Notwendige Cookies sind immer aktiv, weil die Website sie zum Funktionieren benötigt. Falls wir Analysen aktivieren, laufen diese nur nach Ihrer Zustimmung."
    },
    "table": {
      "name": "Name",
      "provider": "Anbieter",
      "purpose": "Zweck",
      "expiration": "Ablauf",
      "type": "Typ"
    },
    "page": {
      "title": "Cookies bei Fyrrehaven 61",
      "intro": "Hier können Sie lesen, wie wir Cookies verwenden und wie Sie Ihre Einstellungen ändern.",
      "typesTitle": "Arten von Cookies"
    }
  },
  "privacyPage": {
    "title": "Datenschutzerklärung",
    "lead": "Diese Erklärung beschreibt, wie wir als Verantwortlicher personenbezogene Daten nach der DSGVO und geltendem dänischem Recht verarbeiten.",
    "controller": {
      "title": "Verantwortlicher",
      "address": "Fyrrehaven 61, 8585 Glesborg, Dänemark",
      "emailLabel": "E-Mail",
      "phoneLabel": "Telefon",
      "dpo": "Wir haben keinen Datenschutzbeauftragten (DSB) benannt. Bei Fragen kontaktieren Sie uns bitte über die oben genannte E-Mail-Adresse."
    },
    "sections": {
      "scope": {
        "title": "Geltungsbereich und Datenquellen",
        "body": "Diese Erklärung gilt für unsere Website, Kontakt- und Buchungsanfragen über Formulare sowie die Bestellung zusätzlicher Services. Die Daten stammen hauptsächlich von Ihnen (Formulare/Kommunikation), von Ihrem Gerät (technische Protokolle) und in einigen Fällen von Drittplattformen (z. B. Airbnb)."
      },
      "categories": {
        "title": "Kategorien personenbezogener Daten",
        "items": [
          {
            "label": "Kontaktdaten",
            "text": "Name, E-Mail, Telefon, Land."
          },
          {
            "label": "Buchungsdaten",
            "text": "Anreise/Abreise, Nächte, Anzahl der Gäste (Erwachsene/Kinder/Babys), Zweck des Aufenthalts, akzeptierte Gebühren/Preise."
          },
          {
            "label": "Zusatzleistungen",
            "text": "Ausgewählte Leistungen und Mengen (Bettwäsche, Handtücher, Pakete usw.)."
          },
          {
            "label": "Kommunikation",
            "text": "Korrespondenz mit Ihnen (z. B. E-Mails)."
          },
          {
            "label": "Technische Daten",
            "text": "IP-Adresse, Zeitstempel, URLs, Geräte-/Browserinformationen und ähnliche grundlegende Protokolldaten aus Sicherheitsgründen."
          },
          {
            "label": "Besondere Kategorien",
            "text": "Wir verarbeiten keine besonderen Kategorien personenbezogener Daten (Art. 9)."
          }
        ]
      },
      "purposes": {
        "title": "Zwecke und Rechtsgrundlagen",
        "items": [
          {
            "label": "Anfragen und Buchung",
            "text": "Beantwortung von Anfragen, Vorbereitung/Abschluss eines Mietvertrags und Erbringung von Leistungen (Art. 6 Abs. 1 lit. b DSGVO)."
          },
          {
            "label": "Buchhaltung und rechtliche Pflichten",
            "text": "Erfüllung gesetzlicher Verpflichtungen (Art. 6 Abs. 1 lit. c DSGVO)."
          },
          {
            "label": "Sicherheit und Betrieb",
            "text": "IT-Sicherheit, Missbrauchsprävention und Fehlerbehebung (berechtigtes Interesse; Art. 6 Abs. 1 lit. f DSGVO)."
          },
          {
            "label": "Marketing",
            "text": "Nur mit Einwilligung (Art. 6 Abs. 1 lit. a DSGVO)."
          }
        ]
      },
      "necessity": {
        "title": "Sind die Angaben erforderlich?",
        "body": "Wenn wir Informationen anfordern, geschieht dies, um Ihre Anfrage zu beantworten oder eine Buchung abzuschließen bzw. zu verwalten. Ohne diese Informationen können wir den gewünschten Service möglicherweise nicht erbringen."
      },
      "recipients": {
        "title": "Empfänger und internationale Übermittlungen",
        "body": "Wir nutzen vertrauenswürdige Auftragsverarbeiter für Betrieb und Kommunikation (z. B. Hosting, E-Mail und Sicherheit). Diese verarbeiten Daten nur nach unseren Weisungen und auf Grundlage geeigneter Auftragsverarbeitungsverträge. Bei Übermittlungen außerhalb der EU/des EWR nutzen wir gültige Übermittlungsgrundlagen (typischerweise EU-Standardvertragsklauseln, SCC).",
        "items": [
          {
            "label": "E-Mail",
            "text": "Formularübermittlungen werden als E-Mails an unser Postfach bei Simply (E-Mail-Anbieter) zugestellt."
          },
          {
            "label": "Drittplattformen",
            "text": "Wenn Sie Links zu z. B. Airbnb oder sozialen Medien nutzen, sind diese für ihre Verarbeitung eigenständige Verantwortliche."
          }
        ]
      },
      "storage": {
        "title": "Speicherung und Zugriff auf Daten",
        "paragraphs": [
          "Wir speichern Ihre Daten nicht in einer separaten Datenbank. Alle Informationen, die Sie über unsere Formulare übermitteln, werden als E-Mail an unser Postfach bei Simply gesendet und dort gespeichert. Wir greifen nur über den E-Mail-Client/Webmail von Simply auf personenbezogene Daten zu.",
          "Die Übertragung von E-Mails erfolgt grundsätzlich per TLS, sofern der empfangende Server dies unterstützt."
        ]
      },
      "retention": {
        "title": "Aufbewahrungsfristen",
        "items": [
          "Anfragen (im Posteingang): normalerweise bis zu 12 Monate, sofern die Korrespondenz nicht Teil einer Buchung oder eines Rechtsanspruchs ist.",
          "Buchungs- und Buchhaltungsdaten in E-Mails/Anhängen: grundsätzlich 5 Jahre aufgrund buchhalterischer Vorschriften.",
          "Sicherheits-/Zugriffsprotokolle: typischerweise 6 Monate."
        ]
      },
      "cookies": {
        "title": "Cookies und ähnliche Technologien",
        "body": "Wir verwenden technisch notwendige Cookies/Speicherungen, um die Website sicher bereitzustellen und Ihre Cookie-Einstellungen zu speichern. Optionale Analysen laufen nur, wenn Sie Statistik-Cookies aktiv erlauben."
      },
      "rights": {
        "title": "Ihre Rechte",
        "items": [
          "Auskunft (Art. 15)",
          "Berichtigung (Art. 16)",
          "Löschung (Art. 17)",
          "Einschränkung der Verarbeitung (Art. 18)",
          "Datenübertragbarkeit (Art. 20)",
          "Widerspruch gegen die Verarbeitung (Art. 21)",
          "Widerruf der Einwilligung (Art. 7 Abs. 3) — ohne Auswirkungen auf die Rechtmäßigkeit vor dem Widerruf."
        ],
        "paragraphs": [
          "Schreiben Sie uns an die oben genannte E-Mail-Adresse, um Ihre Rechte auszuüben. Wir antworten grundsätzlich innerhalb eines Monats und können eine Identifizierung verlangen.",
          "Sie können Beschwerde bei der dänischen Datenschutzbehörde einlegen: www.datatilsynet.dk."
        ]
      },
      "automated": {
        "title": "Automatisierte Entscheidungen",
        "body": "Wir treffen keine automatisierten Entscheidungen und führen kein Profiling durch, das rechtliche Wirkung entfaltet oder Sie in ähnlicher Weise erheblich beeinträchtigt (Art. 22)."
      },
      "changes": {
        "title": "Änderungen dieser Erklärung",
        "body": "Wir aktualisieren diese Erklärung, wenn sich unsere Verarbeitung ändert oder gesetzliche Vorgaben dies erfordern. Wesentliche Änderungen werden hier veröffentlicht.",
        "updatedLabel": "Zuletzt aktualisiert",
        "updated": "16. September 2025"
      },
      "contact": {
        "title": "Kontakt",
        "body": "Wenn Sie Fragen zu dieser Datenschutzerklärung haben, können Sie uns gerne kontaktieren."
      }
    }
  }
} as const;
